import { trpc } from '@/data-loaders';

export const useStudyPeriodList = (schoolId: number) => {
  return trpc.schoolUnit.getStudyPeriodBySchoolIdList.useQuery(
    { schoolId },
    {
      retry: false,
      cacheTime: 1000 * 60 * 60 * 24, // 1 day
      enabled: !!schoolId,
    },
  );
};
